import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  ElementRef,
  ViewChild,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'app-search-dropdown',
  templateUrl: './search-dropdown.component.html',
  styleUrls: ['./search-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchDropdownComponent implements AfterViewInit {
  model: string;
  selected = false;
  @ViewChild('searchField', { static: true }) searchField: ElementRef;

  @Input() placeholder = '';
  @Input() searchFailed = false;
  @Input() searching = false;
  @Input() search;
  @Output() selectItem = new EventEmitter<any>();
  @Output() handleSearch = new EventEmitter<string>();
  @Output() reset = new EventEmitter();

  formatter = (state: any) => state.email;

  ngAfterViewInit() {
    this.searchField.nativeElement.select();
  }

  select({ item }) {
    this.selected = true;
    this.selectItem.emit(item);
  }

  focus() {
    this.selected = false;
  }

  blur() {
    if (!this.selected) {
      this.model = '';
      this.reset.emit();
    }
  }
}
